export const INDUSTRIAL_GAS_TURBINE_LOCATIONS = [
  {
    identifier: "DataPlate",
    name: "DataPlate",
    abbreviation: "DataPlate",
    description: "",
    inspectionFor: [],
    isDataPlate: true,
    rectInStructImage: {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    },
    children: []
  },
  {
    identifier: "LPC",
    name: "Low Pressure Compressor",
    abbreviation: "LPC",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 0,
      left: 34,
      width: 48,
      height: 98
    },
    children: [
      {
        identifier: "LPC_00",
        name: "Stage 00",
        abbreviation: "00",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "01_LPC_00"
      },
      {
        identifier: "LPC_01",
        name: "Stage 01",
        abbreviation: "01",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "02_LPC_01"
      },
      {
        identifier: "LPC_02",
        name: "Stage 02",
        abbreviation: "02",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "03_LPC_02"
      },
      {
        identifier: "LPC_03",
        name: "Stage 03",
        abbreviation: "03",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "04_LPC_03"
      },
      {
        identifier: "LPC_04",
        name: "Stage 04",
        abbreviation: "04",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "05_LPC_04"
      },
      {
        identifier: "LPC_05",
        name: "Stage 05",
        abbreviation: "05",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "06_LPC_05"
      }
    ]
  },
  {
    identifier: "HPC",
    name: "High Pressure Compressor",
    abbreviation: "HPC",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 0,
      left: 34,
      width: 48,
      height: 98
    },
    children: [
      {
        identifier: "HPC_00",
        name: "Stage 00",
        abbreviation: "00",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "07_HPC_00"
      },
      {
        identifier: "HPC_01",
        name: "Stage 01",
        abbreviation: "01",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "08_HPC_01"
      },
      {
        identifier: "HPC_02",
        name: "Stage 02",
        abbreviation: "02",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "09_HPC_02"
      },
      {
        identifier: "HPC_03",
        name: "Stage 03",
        abbreviation: "03",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "10_HPC_03"
      },
      {
        identifier: "HPC_04",
        name: "Stage 04",
        abbreviation: "04",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "11_HPC_04"
      },
      {
        identifier: "HPC_05",
        name: "Stage 05",
        abbreviation: "05",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "12_HPC_05"
      },
      {
        identifier: "HPC_06",
        name: "Stage 06",
        abbreviation: "06",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "13_HPC_06"
      },
      {
        identifier: "HPC_07",
        name: "Stage 07",
        abbreviation: "07",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "14_HPC_07"
      },
      {
        identifier: "HPC_08",
        name: "Stage 08",
        abbreviation: "08",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "15_HPC_08"
      },
      {
        identifier: "HPC_09",
        name: "Stage 09",
        abbreviation: "09",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "16_HPC_09"
      },
      {
        identifier: "HPC_10",
        name: "Stage 10",
        abbreviation: "10",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "17_HPC_10"
      },
      {
        identifier: "HPC_11",
        name: "Stage 11",
        abbreviation: "11",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "18_HPC_11"
      },
      {
        identifier: "HPC_12",
        name: "Stage 12",
        abbreviation: "12",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "19_HPC_12"
      },
      {
        identifier: "HPC_14",
        name: "Stage 14",
        abbreviation: "14",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "20_HPC_14"
      }
    ]
  },
  {
    identifier: "CC",
    name: "Combustion Chamber",
    abbreviation: "CC",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 0,
      left: 22,
      width: 10,
      height: 98
    },
    children: []
  },
  {
    identifier: "HPT",
    name: "High Pressure Turbine",
    abbreviation: "HPT",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 0,
      left: 12,
      width: 9,
      height: 98
    },
    children: [
      {
        identifier: "HPT_01",
        name: "Stage 01",
        abbreviation: "01",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "22_HPT_01"
      },
      {
        identifier: "HPT_02",
        name: "Stage 02",
        abbreviation: "02",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "23_HPT_02"
      }
    ]
  },
  {
    identifier: "LPT",
    name: "Low Pressure Turbine",
    abbreviation: "LPT",
    description: "",
    inspectionFor: [],
    isDataPlate: false,
    rectInStructImage: {
      top: 0,
      left: 12,
      width: 9,
      height: 98
    },
    children: [
      {
        identifier: "LPT_01",
        name: "Stage 01",
        abbreviation: "01",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "24_LPT_01"
      },
      {
        identifier: "LPT_02",
        name: "Stage 02",
        abbreviation: "02",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "25_LPT_02"
      },
      {
        identifier: "LPT_03",
        name: "Stage 03",
        abbreviation: "03",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: 0,
          left: 0,
          width: 0,
          height: 0
        },
        children: [],
        folderName: "26_LPT_03"
      },
      {
        identifier: "LPT_04",
        name: "Stage 04",
        abbreviation: "04",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "27_LPT_04"
      },
      {
        identifier: "LPT_05",
        name: "Stage 05",
        abbreviation: "05",
        description: "",
        inspectionFor: [],
        isDataPlate: false,
        rectInStructImage: {
          top: null,
          left: null,
          width: null,
          height: null
        },
        children: [],
        folderName: "28_LPT_05"
      }
    ]
  }
];
